export const bookInfo = {
  title: "The Quantum Awakening",
  subtitle: "A Chronicle of Humanity's Ascension",
  author: "Andrei Ciomîrtan",
  coverImage: "https://media-manager-c.questera.ai/greta-media/ae05bbc051fb17176d2c348bf77438a7a494626431a725f22ebe70ac4579d949c16512ea83019a888cf26e0e50680ce7/images/aW1hZ2UvanBlZw==/b5a489e59824de376ec7261de27bf74c.jpg",
  authorImage: "https://media-manager-c.questera.ai/greta-media/ae05bbc051fb17176d2c348bf77438a7a494626431a725f22ebe70ac4579d949c16512ea83019a888cf26e0e50680ce7/images/aW1hZ2UvanBlZw==/91ab01df2fc17bd64fc03588a793bcb6.jpg",
  overallArc: "The book moves from survival → expansion → reflection → transcendence, tracing humanity's journey from nearly destroying its home world to becoming a multi-planetary, interstellar-reaching species — scarred, wiser, and still reaching outward.",
  closingQuote: "Ascension is not a destination. It is a motion. It is the direction, not the arrival. We are still ascending.",
  links: {
    amazon: {
      kindle: "https://www.amazon.com/dp/B0GXDZXVNV",
      paperback: "https://www.amazon.com/dp/B0GXKS9ZSV",
      hardcover: "https://www.amazon.com/dp/B0GXK8VRZJ"
    },
    website: {
      en: "https://ciomirtan.com/book/the-quantum-awakening-a-chronicle-of-humanitys-ascension/",
      ro: "https://ciomirtan.com/book/trezirea-cuantica-o-cronica-a-ascensiunii-umane/"
    }
  }
};

export const chapters = [
  {
    num: 1,
    title: "The Quantum Awakening",
    era: "2067–2075",
    world: "Earth / Zurich",
    desc: "The story begins with humanity's first breakthrough in quantum computing and artificial intelligence, set in a Zurich laboratory. A lethal pandemic (Marburg-X) looms in the background, killing 340 million people in three years. This chapter establishes the dual nature of the era — extraordinary technological leaps happening alongside catastrophic human suffering.",
    color: "from-blue-900/30 to-brand-dark"
  },
  {
    num: 2,
    title: "Mercury: The Forge of Civilization",
    era: "2110–2200",
    world: "Mercury",
    desc: "Humanity's first permanent foothold in the inner solar system. Mercury becomes the industrial engine of civilization — a world of extremes used to harvest solar energy and mine rare materials. Life here is defined by the terminator zone, where colonists chase the narrow band between scorching heat and frozen darkness.",
    color: "from-orange-900/30 to-brand-dark"
  },
  {
    num: 3,
    title: "Venus: The Reborn World",
    era: "2290–2501",
    world: "Venus",
    desc: "The most detailed and visually rich chapter. Spanning from 2290 to 2501, it chronicles the complete terraforming of Venus — the deployment of the Ishtar Sunshade, 97 years of ice delivery from Jupiter's moons, the creation of three oceans, and the construction of an artificial magnetosphere. By 2501, Venus is a warm, amber-skied paradise with a population of one million.",
    color: "from-amber-900/30 to-brand-dark"
  },
  {
    num: 4,
    title: "Earth: The Wounded Mother",
    era: "2058–2350",
    world: "Earth",
    desc: "The hardest chapter to read. A sober chronicle of Earth's collapse — climate change pushing temperatures past 2.8°C, the death of coral reefs, the Amazon tipping into savanna, agricultural collapse, and the displacement of 2 billion climate refugees. Told through individual human stories rather than statistics, it is a story of unnecessary suffering and hard-won redemption.",
    color: "from-green-900/30 to-brand-dark"
  },
  {
    num: 5,
    title: "Mars: The Red Republic",
    era: "2180–2400",
    world: "Mars",
    desc: "Mars emerges as humanity's first truly independent planetary civilization — politically bold, culturally distinct, and philosophically committed to self-governance. This chapter follows the arc from early terraforming domes to a fully fledged Martian republic, exploring what it means for a people born on another world to define their own identity.",
    color: "from-red-900/30 to-brand-dark"
  },
  {
    num: 6,
    title: "The Belt: The Free People",
    era: "2220–2450",
    world: "Asteroid Belt",
    desc: "The Asteroid Belt becomes home to a unique and fiercely independent civilization of miners, traders, and wanderers. Belters develop their own creole language laced with navigational metaphors, their own social codes, and a culture built around movement, scarcity, and self-reliance.",
    color: "from-gray-700/30 to-brand-dark"
  },
  {
    num: 7,
    title: "Jupiter: The Giant's Children",
    era: "2260–2420",
    world: "Jupiter System",
    desc: "Humanity settles the Jovian system — the moons Europa, Ganymede, and Callisto. The ice moons become sources of the water that fed the Venus terraforming. The chapter explores the engineering marvels of subsurface ocean access on Europa and the philosophical questions raised by possible microbial life beneath the ice.",
    color: "from-yellow-900/30 to-brand-dark"
  },
  {
    num: 8,
    title: "Saturn: The Ringed Cathedral",
    era: "2310–2470",
    world: "Saturn / Titan",
    desc: "Saturn's moons, particularly Titan with its thick nitrogen atmosphere and hydrocarbon lakes, become an unlikely cultural heartland — a place of artists, philosophers, and those drawn to sublime beauty. Life on Titan is slow, contemplative, and deeply aesthetic, in contrast to the industrial pace of the inner system.",
    color: "from-purple-900/30 to-brand-dark"
  },
  {
    num: 9,
    title: "Neptune: The Deep Blue Frontier",
    era: "2418–2510",
    world: "Neptune / Triton",
    desc: "The most remote permanent human settlement: Triton Station, founded in 2418 on Neptune's largest moon. At -235°C, engineering here pushes materials science to its absolute limits. The Neptunians develop a quiet, patient, sentinel culture — embodied by the Geyser Watch, a civic ritual of sustained attention.",
    color: "from-blue-950/50 to-brand-dark"
  },
  {
    num: 10,
    title: "The Gaia Compact: A Species Reborn",
    era: "2480–2510",
    world: "Solar System",
    desc: "A turning point chapter that steps back from individual worlds to look at humanity as a whole. The Gaia Compact is the political and philosophical framework that binds the solar civilization together — born from the lessons of Earth's near-destruction. This chapter is about collective memory and accountability.",
    color: "from-teal-900/30 to-brand-dark"
  },
  {
    num: 11,
    title: "The Odyssey: Humanity's First Step to the Stars",
    era: "2514",
    world: "Interstellar",
    desc: "The triumphant closing chapter. Humanity launches its first interstellar mission — the Odyssey — toward Alpha Centauri. And then, just as the ship departs, a signal arrives from deep space. Unexplained. Deliberate. The chronicle ends deliberately unfinished — the next chapter is ours to write.",
    color: "from-indigo-900/30 to-brand-dark"
  }
];

export const families = [
  {
    name: "The Vasquezes",
    origin: "Zurich / Earth",
    desc: "Beginning with Dr. Elena Vasquez, whose quantum processor ignited the awakening, this lineage carries the burden and gift of invention across generations.",
    accent: "text-amber-400"
  },
  {
    name: "The Tanakas",
    origin: "Mercury / Inner System",
    desc: "Engineers and industrialists forged in the crucible of Mercury's terminator zones, the Tanakas built the infrastructure that powered a solar civilization.",
    accent: "text-orange-400"
  },
  {
    name: "The Osei-Okonkwos",
    origin: "Earth / Venus",
    desc: "From Kinshasa to the amber shores of terraformed Venus, this family's story spans Earth's darkest hour and humanity's most beautiful redemption.",
    accent: "text-green-400"
  },
  {
    name: "The Rivera-Mwangis",
    origin: "Neptune / Interstellar",
    desc: "Culminating in Eseosa Rivera-Mwangi, director of Neptune's Heliopause Observatory, this lineage stands at the edge of everything — listening.",
    accent: "text-blue-400"
  }
];

export const keyMoments = [
  { year: "2067", event: "Marburg-X pandemic begins", detail: "340 million lives lost in three years" },
  { year: "2071", event: "Dr. Elena Vasquez creates first stable quantum processor", detail: "The spark of the Quantum Awakening" },
  { year: "2110", event: "First Mercury colony established", detail: "Humanity's first permanent off-world home" },
  { year: "2180", event: "Mars terraforming begins", detail: "Domed cities begin to rise in red deserts" },
  { year: "2290", event: "Venus terraforming initiated", detail: "The Ishtar Sunshade deployed" },
  { year: "2418", event: "Triton Station founded", detail: "Humanity reaches Neptune, -235°C" },
  { year: "2480", event: "The Gaia Compact signed", detail: "Eight worlds bound by one covenant" },
  { year: "2501", event: "Venus declared paradise", detail: "Population: one million, amber skies and warm oceans" },
  { year: "2514", event: "Project Odyssey launches", detail: "First crewed interstellar mission to Alpha Centauri" },
  { year: "2514", event: "The Signal detected", detail: "A recursive, self-referencing transmission from deep space" }
];